
// import React, { useState } from 'react';
// import axios from 'axios';
// import {
//   Box,
//   Button,
//   Typography,
//   TextField,
//   useMediaQuery,
//   InputAdornment,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   Divider,
// } from '@mui/material';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import LocationCityIcon from '@mui/icons-material/LocationCity';
// import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import backgroundImage from '../../../assets/hij.png';
// import { useSelector } from 'react-redux';
// import { selectUser } from '../../../Commonlibs/userSlice';
// import { useTabContext } from './TabContext';

// const HeroSection = () => {
//   const { activeTab, setActiveTab } = useTabContext();
//   const [city, setCity] = useState('');
//   const [citySuggestions, setCitySuggestions] = useState([]);
//   const [showCitySuggestions, setShowCitySuggestions] = useState(false);
//   const [showPopularCities, setShowPopularCities] = useState(false);
//   const [area, setArea] = useState('');
//   const [areaSuggestions, setAreaSuggestions] = useState([]);
//   const [showAreaSuggestions, setShowAreaSuggestions] = useState(false);

//   const [cityDebounceTimer, setCityDebounceTimer] = useState(null);
//   const [areaDebounceTimer, setAreaDebounceTimer] = useState(null);

//   const [cityError, setCityError] = useState('');
//   const [areaError, setAreaError] = useState('');

//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [dialogMessage, setDialogMessage] = useState('');
//   const [dialogSeverity, setDialogSeverity] = useState('info');

//   const [areaCacheMap, setAreaCacheMap] = useState({});
//   const [isLoadingAreas, setIsLoadingAreas] = useState(false);

//   const theme = useTheme();
//   const navigate = useNavigate();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const user = useSelector(selectUser);

//   const tabs = ['Buy', 'Rent', 'Plot'];

//   const categoryMap = {
//     'Buy': 'sale',
//     'Rent': 'rent',
//     'Plot': 'plot',
//   };

//   // Dynamic typography based on active tab
//   const getHeadingText = () => {
//     switch (activeTab) {
//       case 'Buy':
//         return 'Find Your Dream Property to Buy!';
//       case 'Rent':
//         return 'Discover Perfect Rental Properties!';
//       case 'Plot':
//         return 'Explore Prime Plots for Sale!';
//       default:
//         return 'Buy, Sell, Rent a Property made easy!';
//     }
//   };

//   const getSubheadingText = () => {
//     switch (activeTab) {
//       case 'Buy':
//         return 'Browse through thousands of properties available for purchase';
//       case 'Rent':
//         return 'Find the perfect rental home from our extensive listings';
//       case 'Plot':
//         return 'Invest in residential and commercial plots at prime locations';
//       default:
//         return 'Browse through thousands of properties for sale and rent';
//     }
//   };

//   const topCities = [
//     { name: 'Hyderabad', state: 'Telangana' },
//     { name: 'Vijayawada', state: 'Andhra Pradesh' },
//     { name: 'Visakhapatnam', state: 'Andhra Pradesh' },
//   ];

//   const otherCities = [
//     { name: 'Guntur', state: 'Andhra Pradesh' },
//     { name: 'Nellore', state: 'Andhra Pradesh' },
//     { name: 'Kurnool', state: 'Andhra Pradesh' },
//     { name: 'Rajahmundry', state: 'Andhra Pradesh' },
//     { name: 'Tirupati', state: 'Andhra Pradesh' },
//     { name: 'Kakinada', state: 'Andhra Pradesh' },
//     { name: 'Warangal', state: 'Telangana' },
//     { name: 'Nizamabad', state: 'Telangana' },
//     { name: 'Karimnagar', state: 'Telangana' },
//     { name: 'Khammam', state: 'Telangana' },
//   ];

//   const handleCloseDialog = () => {
//     setDialogOpen(false);
//   };

//   const showDialog = (message, severity = 'info') => {
//     setDialogMessage(message);
//     setDialogSeverity(severity);
//     setDialogOpen(true);
//   };

//   const validateCity = (value) => {
//     if (value) {
//       if (!/^[a-zA-Z\s]+$/.test(value)) {
//         setCityError('City should contain only letters and spaces');
//         return false;
//       }
//     }
//     setCityError('');
//     return true;
//   };

//   const validateArea = (value) => {
//     if (value) {
//       if (!/^[a-zA-Z0-9\s,.-]+$/.test(value)) {
//         setAreaError('Area should contain only alphanumeric characters, spaces and basic punctuation');
//         return false;
//       }
//     }
//     setAreaError('');
//     return true;
//   };

//   const fetchCitySuggestions = async (query) => {
//     if (!query || query.trim().length < 1) {
//       setCitySuggestions([]);
//       setShowCitySuggestions(false);
//       setShowPopularCities(false);
//       return;
//     }

//     try {
//       const response = await axios.get(
//         `https://propertydealstalk.com/api/property/cities?q=${encodeURIComponent(query)}`
//       );

//       if (response.data.success && response.data.data && response.data.data.length > 0) {
//         setCitySuggestions(response.data.data);
//         setShowCitySuggestions(true);
//         setShowPopularCities(false);
//       } else {
//         setCitySuggestions([]);
//         setShowCitySuggestions(false);
//       }
//     } catch (error) {
//       console.error('Error fetching city suggestions:', error);
//       setCitySuggestions([]);
//       setShowCitySuggestions(false);
//     }
//   };

//   const fetchAreaSuggestions = async (query) => {
//     if (!city || city.trim() === '') {
//       setAreaSuggestions([]);
//       setShowAreaSuggestions(false);
//       return;
//     }

//     const cacheKey = `${city.trim()}_${query.trim()}`;

//     if (areaCacheMap[cacheKey]) {
//       setAreaSuggestions(areaCacheMap[cacheKey]);
//       setShowAreaSuggestions(true);
//       return;
//     }

//     setIsLoadingAreas(true);

//     try {
//       const response = await axios.get(
//         `https://propertydealstalk.com/api/property/getAreasByCity?city=${encodeURIComponent(city)}&q=${encodeURIComponent(query)}`
//       );

//       if (response.data.success && response.data.areas && response.data.areas.length > 0) {
//         setAreaCacheMap(prev => ({
//           ...prev,
//           [cacheKey]: response.data.areas
//         }));

//         setAreaSuggestions(response.data.areas);
//         setShowAreaSuggestions(true);
//       } else {
//         setAreaSuggestions([]);
//         setShowAreaSuggestions(false);
//       }
//     } catch (error) {
//       console.error('Error fetching area suggestions:', error);
//       setAreaSuggestions([]);
//       setShowAreaSuggestions(false);
//     } finally {
//       setIsLoadingAreas(false);
//     }
//   };

//   const saveBuyerSearch = async (searchData) => {
//     try {
//       const response = await axios.post(
//         'https://propertydealstalk.com/api/buyerAnalytics/saveBuyerSearch',
//         searchData
//       );

//       if (response.data.statusCode === 200) {
//         console.log('Search saved successfully:', response.data);
//       }
//     } catch (error) {
//       console.error('Error saving search:', error);
//     }
//   };

//   const handleSearch = async () => {
//     const isCityValid = validateCity(city);
//     const isAreaValid = validateArea(area);

//     if (!isCityValid || !isAreaValid) {
//       return;
//     }

//     const hasCity = city && city.trim() !== '';
//     const hasArea = area && area.trim() !== '';

//     if (!hasCity) {
//       showDialog("Please select a city to search", "warning");
//       return;
//     }

//     const params = new URLSearchParams();
//     const categoryType = categoryMap[activeTab];

//     if (activeTab === 'Plot') {
//       params.append('asset_type', 'plot');
//     } else if (categoryType) {
//       params.append('category', categoryType);
//     }

//     params.append('city', city.trim());
    
//     if (hasArea) {
//       params.append('area_name', area.trim());
//     }

//     if (user && user.id) {
//       const searchData = {
//         buyer_id: user.id,
//         location: city.trim(),
//         area: hasArea ? area.trim() : null,
//         property_type: null,
//         min_price: null,
//         max_price: null
//       };
//       await saveBuyerSearch(searchData);
//     }

//     navigate({
//       pathname: '/property',
//       search: params.toString()
//     });

//     showDialog('Searching for properties...', 'success');
//   };

//   const handleCityChange = (e) => {
//     const value = e.target.value;
//     setCity(value);
//     validateCity(value);

//     if (cityDebounceTimer) {
//       clearTimeout(cityDebounceTimer);
//     }

//     const newTimer = setTimeout(() => {
//       if (value.trim().length >= 1) {
//         fetchCitySuggestions(value.trim());
//       } else {
//         setCitySuggestions([]);
//         setShowCitySuggestions(false);
//         setShowPopularCities(false);
//       }
//     }, 300);

//     setCityDebounceTimer(newTimer);
//   };

//   const handleAreaChange = (e) => {
//     if (!city || city.trim() === '') {
//       showDialog("Please select city first", "warning");
//       return;
//     }

//     const value = e.target.value;
//     setArea(value);
//     validateArea(value);

//     if (areaDebounceTimer) {
//       clearTimeout(areaDebounceTimer);
//     }

//     const newTimer = setTimeout(() => {
//       if (city && city.trim() !== '') {
//         fetchAreaSuggestions(value);
//       }
//     }, 100);

//     setAreaDebounceTimer(newTimer);
//   };

//   const handleCitySelect = (cityName) => {
//     setCity(cityName);
//     setCityError('');
//     setShowPopularCities(false);
//     setShowCitySuggestions(false);
    
//     setArea('');
//     setAreaSuggestions([]);
//     setAreaCacheMap({});
//   };

//   const handleAreaFocus = (e) => {
//     if (!city || city.trim() === '') {
//       e.preventDefault();
//       e.target.blur();
//       showDialog("Please select city first", "warning");
//       return;
//     }

//     if (areaSuggestions.length > 0) {
//       setShowAreaSuggestions(true);
//     } else if (area.trim().length === 0) {
//       fetchAreaSuggestions('');
//     }
//   };

//   const handleAreaClick = (e) => {
//     if (!city || city.trim() === '') {
//       e.preventDefault();
//       showDialog("Please select city first", "warning");
//     }
//   };

//   return (
//     <Box
//       sx={{
//         position: 'relative',
//         height: '600px',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         backgroundImage: `url(${backgroundImage})`,
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//         color: 'white',
//         fontFamily: 'Outfit',
//         px: '16px',
//       }}
//     >
//       <Dialog
//         open={dialogOpen}
//         onClose={handleCloseDialog}
//         aria-labelledby="alert-dialog-title"
//         aria-describedby="alert-dialog-description"
//         PaperProps={{
//           sx: {
//             width: '250px',
//             height: '150px',
//             maxWidth: '250px',
//             maxHeight: '150px',
//           }
//         }}
//       >
//         <DialogTitle id="alert-dialog-title" sx={{ padding: '12px 16px' }}>
//           {dialogSeverity === 'success' ? 'Success' :
//             dialogSeverity === 'warning' ? 'Warning' :
//               dialogSeverity === 'error' ? 'Error' : 'Information'}
//         </DialogTitle>
//         <DialogContent sx={{ padding: '8px 16px' }}>
//           <DialogContentText id="alert-dialog-description">
//             {dialogMessage}
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions sx={{ padding: '8px 16px' }}>
//           <Button onClick={handleCloseDialog} autoFocus>
//             OK
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Box
//         sx={{
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '100%',
//           backgroundColor: 'rgba(0,0,0,0.6)',
//           zIndex: 1,
//         }}
//       />

//       <Box
//         sx={{
//           position: 'relative',
//           zIndex: 2,
//           width: '880px',
//           maxWidth: '100%',
//           fontFamily: 'Outfit',
//         }}
//       >
//         {/* Dynamic Typography based on active tab */}
//         <Typography
//           variant="h3"
//           sx={{
//             textAlign: 'center',
//             fontWeight: 500,
//             mb: '8px',
//             fontSize: isMobile ? '28px' : '40px',
//             fontFamily: 'Outfit',
//           }}
//         >
//           {getHeadingText()}
//         </Typography>

//         <Typography
//           variant="h6"
//           sx={{
//             textAlign: 'center',
//             fontWeight: 500,
//             mb: '32px',
//             fontSize: isMobile ? '16px' : '20px',
//             fontFamily: 'Outfit',
//           }}
//         >
//           {getSubheadingText()}
//         </Typography>

//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: 'row',
//             justifyContent: isMobile ? 'center' : 'flex-start',
//             flexWrap: 'wrap',
//             gap: isMobile ? '5px' : '10px',
//             px: isMobile ? '0px' : '30px',
//             mb: '0px',
//           }}
//         >
//           {tabs.map((label) => (
//             <Box
//               key={label}
//               onClick={() => setActiveTab(label)}
//               sx={{
//                 width: isMobile ? '100px' : '160px',
//                 height: '40px',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 borderTopLeftRadius: '8px',
//                 borderTopRightRadius: '8px',
//                 fontWeight: 500,
//                 fontFamily: 'Outfit',
//                 fontSize: '14px',
//                 textTransform: 'uppercase',
//                 cursor: 'pointer',
//                 backgroundColor: activeTab === label ? '#0052ff' : '#ffffff',
//                 color: activeTab === label ? '#ffffff' : '#000000',
//                 boxShadow: activeTab === label ? '0px 2px 8px rgba(0, 0, 0, 0.2)' : 'none',
//                 border: '1px solid grey',
//                 transition: 'all 0.3s ease',
//                 '&:hover': {
//                   backgroundColor: activeTab === label ? '#0041cc' : '#f5f5f5',
//                 },
//               }}
//             >
//               {label}
//             </Box>
//           ))}
//         </Box>

//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: isMobile ? 'column' : 'row',
//             alignItems: 'center',
//             justifyContent: 'flex-start',
//             backgroundColor: '#fff',
//             borderRadius: '12px',
//             padding: '20px',
//             mt: '0px',
//             ml: isMobile ? '0px' : '24px',
//             mr: isMobile ? '0px' : '24px',
//             gap: '16px',
//             flexWrap: 'wrap',
//             boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//             fontFamily: 'Outfit',
//           }}
//         >
//           <Box sx={{ position: 'relative', width: isMobile ? '100%' : '320px' }}>
//             <TextField
//               variant="outlined"
//               placeholder="City"
//               value={city}
//               onChange={handleCityChange}
//               onBlur={() => {
//                 setTimeout(() => {
//                   setShowCitySuggestions(false);
//                   setShowPopularCities(false);
//                 }, 200);
//               }}
//               onFocus={() => {
//                 if (city.trim().length === 0) {
//                   setShowPopularCities(true);
//                   setShowCitySuggestions(false);
//                 } else if (city.trim().length >= 1 && citySuggestions.length > 0) {
//                   setShowCitySuggestions(true);
//                   setShowPopularCities(false);
//                 } else if (city.trim().length >= 1) {
//                   fetchCitySuggestions(city.trim());
//                 }
//               }}
//               fullWidth={isMobile}
//               error={!!cityError}
//               helperText={cityError}
//               sx={{
//                 width: '100%',
//                 '& .MuiInputBase-root': {
//                   height: '44px',
//                   fontFamily: 'Outfit',
//                   fontWeight: 500,
//                 },
//                 '& input': {
//                   padding: '10px 12px',
//                   fontWeight: 500,
//                   color: '#626262',
//                   fontFamily: 'Outfit',
//                 },
//                 '& .MuiFormHelperText-root': {
//                   color: 'red',
//                   marginTop: '2px',
//                   fontSize: '12px',
//                 },
//               }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <LocationOnIcon sx={{ color: '#aaa' }} />
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             {showPopularCities && (
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   top: '44px',
//                   left: 0,
//                   right: 0,
//                   zIndex: 10,
//                   maxHeight: '350px',
//                   overflowY: 'auto',
//                   backgroundColor: '#fff',
//                   boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//                   borderRadius: '4px',
//                   mt: '4px',
//                   border: '1px solid #e0e0e0',
//                 }}
//               >
//                 <Box sx={{ padding: '12px 16px', backgroundColor: '#f8f9fa' }}>
//                   <Typography sx={{ fontWeight: 600, fontSize: '13px', color: '#666', textTransform: 'uppercase' }}>
//                     Top Cities
//                   </Typography>
//                 </Box>
//                 {topCities.map((cityItem, index) => (
//                   <Box
//                     key={`top-city-${index}`}
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       padding: '12px 16px',
//                       cursor: 'pointer',
//                       borderBottom: '1px solid #f0f0f0',
//                       '&:hover': {
//                         backgroundColor: '#f5f5f5',
//                       },
//                       fontFamily: 'Outfit',
//                     }}
//                     onMouseDown={(e) => {
//                       e.preventDefault();
//                       e.stopPropagation();
//                       handleCitySelect(cityItem.name);
//                     }}
//                   >
//                     <LocationCityIcon sx={{ color: '#0052ff', fontSize: '20px', mr: 1.5 }} />
//                     <Box>
//                       <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#333' }}>
//                         {cityItem.name}
//                       </Typography>
//                       <Typography sx={{ fontSize: '12px', color: '#999' }}>
//                         {cityItem.state}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 ))}

//                 <Divider sx={{ my: 1 }} />

//                 <Box sx={{ padding: '12px 16px', backgroundColor: '#f8f9fa' }}>
//                   <Typography sx={{ fontWeight: 600, fontSize: '13px', color: '#666', textTransform: 'uppercase' }}>
//                     Other Cities
//                   </Typography>
//                 </Box>
//                 {otherCities.map((cityItem, index) => (
//                   <Box
//                     key={`other-city-${index}`}
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       padding: '12px 16px',
//                       cursor: 'pointer',
//                       borderBottom: index < otherCities.length - 1 ? '1px solid #f0f0f0' : 'none',
//                       '&:hover': {
//                         backgroundColor: '#f5f5f5',
//                       },
//                       fontFamily: 'Outfit',
//                     }}
//                     onMouseDown={(e) => {
//                       e.preventDefault();
//                       e.stopPropagation();
//                       handleCitySelect(cityItem.name);
//                     }}
//                   >
//                     <LocationOnIcon sx={{ color: '#666', fontSize: '20px', mr: 1.5 }} />
//                     <Box>
//                       <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#333' }}>
//                         {cityItem.name}
//                       </Typography>
//                       <Typography sx={{ fontSize: '12px', color: '#999' }}>
//                         {cityItem.state}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 ))}
//               </Box>
//             )}

//             {showCitySuggestions && citySuggestions.length > 0 && (
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   top: '44px',
//                   left: 0,
//                   right: 0,
//                   zIndex: 10,
//                   maxHeight: '200px',
//                   overflowY: 'auto',
//                   backgroundColor: '#fff',
//                   boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
//                   borderRadius: '4px',
//                   mt: '4px',
//                   border: '1px solid #e0e0e0',
//                 }}
//               >
//                 {citySuggestions.map((suggestion, index) => (
//                   <Box
//                     key={`city-${suggestion.id}-${index}`}
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       padding: '10px 12px',
//                       cursor: 'pointer',
//                       borderBottom: index < citySuggestions.length - 1 ? '1px solid #f0f0f0' : 'none',
//                       '&:hover': {
//                         backgroundColor: '#f5f5f5',
//                       },
//                       fontFamily: 'Outfit',
//                     }}
//                     onMouseDown={(e) => {
//                       e.preventDefault();
//                       e.stopPropagation();
//                       setCity(suggestion.name);
//                       setCityError('');
//                       setShowCitySuggestions(false);
//                       setArea('');
//                       setAreaSuggestions([]);
//                       setAreaCacheMap({});
//                     }}
//                   >
//                     <LocationOnIcon sx={{ color: '#666', fontSize: '20px', mr: 1.5 }} />
//                     <Box>
//                       <Typography sx={{ fontWeight: 900, fontSize: '14px', color: '#333' }}>
//                         {suggestion.name}
//                       </Typography>
//                       {suggestion.state_name && (
//                         <Typography sx={{ fontWeight: 500, fontSize: '12px', color: '#999' }}>
//                           {suggestion.state_name}
//                         </Typography>
//                       )}
//                     </Box>
//                   </Box>
//                 ))}
//               </Box>
//             )}
//           </Box>

//           <Box sx={{ position: 'relative', width: isMobile ? '100%' : '320px' }}>
//             <TextField
//               variant="outlined"
//               placeholder="Area"
//               value={area}
//               onChange={handleAreaChange}
//               onClick={handleAreaClick}
//               onBlur={() => {
//                 setTimeout(() => setShowAreaSuggestions(false), 200);
//               }}
//               onFocus={handleAreaFocus}
//               fullWidth={isMobile}
//               error={!!areaError}
//               helperText={areaError}
//               sx={{
//                 width: '100%',
//                 '& .MuiInputBase-root': {
//                   height: '44px',
//                   fontFamily: 'Outfit',
//                   fontWeight: 500,
//                   cursor: (!city || city.trim() === '') ? 'not-allowed' : 'text',
//                 },
//                 '& input': {
//                   padding: '10px 12px',
//                   fontWeight: 500,
//                   color: (!city || city.trim() === '') ? '#aaa' : '#626262',
//                   fontFamily: 'Outfit',
//                   cursor: (!city || city.trim() === '') ? 'not-allowed' : 'text',
//                 },
//                 '& .MuiFormHelperText-root': {
//                   color: 'red',
//                   marginTop: '2px',
//                   fontSize: '12px',
//                 },
//               }}
//                           />

//             {showAreaSuggestions && !isLoadingAreas && areaSuggestions.length > 0 && (
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   top: '44px',
//                   left: 0,
//                   right: 0,
//                   zIndex: 10,
//                   maxHeight: '200px',
//                   overflowY: 'auto',
//                   backgroundColor: '#fff',
//                   boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
//                   borderRadius: '4px',
//                   mt: '4px',
//                   border: '1px solid #e0e0e0',
//                 }}
//               >
//                 {areaSuggestions.map((suggestion, index) => (
//                   <Box
//                     key={`area-${index}-${suggestion.name}`}
//                     sx={{
//                       padding: '10px 12px',
//                       cursor: 'pointer',
//                       borderBottom: index < areaSuggestions.length - 1 ? '1px solid #f0f0f0' : 'none',
//                       '&:hover': {
//                         backgroundColor: '#f5f5f5',
//                       },
//                       fontFamily: 'Outfit',
//                       fontWeight: 500,
//                       color: '#626262',
//                     }}
//                     onMouseDown={(e) => {
//                       e.preventDefault();
//                       e.stopPropagation();
//                       setArea(suggestion.name);
//                       setAreaError('');
//                       setShowAreaSuggestions(false);
//                     }}
//                   >
//                     <Box>
//                       <Typography sx={{ fontWeight: 500, fontSize: '14px' }}>
//                         {suggestion.name}
//                       </Typography>
//                       {suggestion.address && (
//                         <Typography sx={{ fontSize: '12px', color: '#999' }}>
//                           {suggestion.address}
//                         </Typography>
//                       )}
//                     </Box>
//                   </Box>
//                 ))}
//               </Box>
//             )}
//           </Box>

//           {/* Search Button */}
//           <Button
//             onMouseDown={(e) => {
//               e.preventDefault();
//             }}
//             onClick={handleSearch}
//             variant="contained"
//             sx={{
//               bgcolor: '#0052ff',
//               color: '#fff',
//               width: isMobile ? '100%' : '120px',
//               height: '44px',
//               textTransform: 'none',
//               fontWeight: 500,
//               fontFamily: 'Outfit',
//               borderRadius: '6px',
//               '&:hover': {
//                 backgroundColor: '#003dcc',
//               },
//             }}
//           >
//             Search
//           </Button>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default HeroSection;

import React, { useState } from 'react';
import axios from 'axios';
import {
  Box,
  Button,
  Typography,
  TextField,
  useMediaQuery,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Divider,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../../../assets/hij.png';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../Commonlibs/userSlice';
import { useTabContext } from './TabContext';

const HeroSection = () => {
  const { activeTab, setActiveTab } = useTabContext();
  const [city, setCity] = useState('');
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [showCitySuggestions, setShowCitySuggestions] = useState(false);
  const [showPopularCities, setShowPopularCities] = useState(false);
  const [area, setArea] = useState('');
  const [areaSuggestions, setAreaSuggestions] = useState([]);
  const [showAreaSuggestions, setShowAreaSuggestions] = useState(false);

  const [cityDebounceTimer, setCityDebounceTimer] = useState(null);
  const [areaDebounceTimer, setAreaDebounceTimer] = useState(null);

  const [cityError, setCityError] = useState('');
  const [areaError, setAreaError] = useState('');

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [dialogSeverity, setDialogSeverity] = useState('info');

  const [areaCacheMap, setAreaCacheMap] = useState({});
  const [isLoadingAreas, setIsLoadingAreas] = useState(false);

  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const user = useSelector(selectUser);

  const tabs = ['Buy', 'Rent', 'Plot'];

  const categoryMap = {
    'Buy': 'sale',
    'Rent': 'rent',
    'Plot': 'plot',
  };

  // Dynamic typography based on active tab
  const getHeadingText = () => {
    switch (activeTab) {
      case 'Buy':
        return 'Find Your Dream Property to Buy!';
      case 'Rent':
        return 'Discover Perfect Rental Properties!';
      case 'Plot':
        return 'Explore Prime Plots for Sale!';
      default:
        return 'Buy, Sell, Rent a Property made easy!';
    }
  };

  const getSubheadingText = () => {
    switch (activeTab) {
      case 'Buy':
        return 'Browse through thousands of properties available for purchase';
      case 'Rent':
        return 'Find the perfect rental home from our extensive listings';
      case 'Plot':
        return 'Invest in residential and commercial plots at prime locations';
      default:
        return 'Browse through thousands of properties for sale and rent';
    }
  };

  const topCities = [
    { name: 'Hyderabad', state: 'Telangana' },
    { name: 'Vijayawada', state: 'Andhra Pradesh' },
    { name: 'Visakhapatnam', state: 'Andhra Pradesh' },
  ];

  const otherCities = [
    { name: 'Guntur', state: 'Andhra Pradesh' },
    { name: 'Nellore', state: 'Andhra Pradesh' },
    { name: 'Kurnool', state: 'Andhra Pradesh' },
    { name: 'Rajahmundry', state: 'Andhra Pradesh' },
    { name: 'Tirupati', state: 'Andhra Pradesh' },
    { name: 'Kakinada', state: 'Andhra Pradesh' },
    { name: 'Warangal', state: 'Telangana' },
    { name: 'Nizamabad', state: 'Telangana' },
    { name: 'Karimnagar', state: 'Telangana' },
    { name: 'Khammam', state: 'Telangana' },
  ];

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const showDialog = (message, severity = 'info') => {
    setDialogMessage(message);
    setDialogSeverity(severity);
    setDialogOpen(true);
  };

  const validateCity = (value) => {
    if (value) {
      if (!/^[a-zA-Z\s]+$/.test(value)) {
        setCityError('City should contain only letters and spaces');
        return false;
      }
    }
    setCityError('');
    return true;
  };

  const validateArea = (value) => {
    if (value) {
      if (!/^[a-zA-Z0-9\s,.-]+$/.test(value)) {
        setAreaError('Area should contain only alphanumeric characters, spaces and basic punctuation');
        return false;
      }
    }
    setAreaError('');
    return true;
  };

  const fetchCitySuggestions = async (query) => {
    if (!query || query.trim().length < 1) {
      setCitySuggestions([]);
      setShowCitySuggestions(false);
      setShowPopularCities(false);
      return;
    }

    try {
      const response = await axios.get(
        `https://propertydealstalk.com/api/property/cities?q=${encodeURIComponent(query)}`
      );

      if (response.data.success && response.data.data && response.data.data.length > 0) {
        setCitySuggestions(response.data.data);
        setShowCitySuggestions(true);
        setShowPopularCities(false);
      } else {
        setCitySuggestions([]);
        setShowCitySuggestions(false);
      }
    } catch (error) {
      console.error('Error fetching city suggestions:', error);
      setCitySuggestions([]);
      setShowCitySuggestions(false);
    }
  };

  const fetchAreaSuggestions = async (query) => {
    if (!city || city.trim() === '') {
      setAreaSuggestions([]);
      setShowAreaSuggestions(false);
      return;
    }

    const cacheKey = `${city.trim()}_${query.trim()}`;

    if (areaCacheMap[cacheKey]) {
      setAreaSuggestions(areaCacheMap[cacheKey]);
      setShowAreaSuggestions(true);
      return;
    }

    setIsLoadingAreas(true);

    try {
      const response = await axios.get(
        `https://propertydealstalk.com/api/property/getAreasByCity?city=${encodeURIComponent(city)}&q=${encodeURIComponent(query)}`
      );

      if (response.data.success && response.data.areas && response.data.areas.length > 0) {
        setAreaCacheMap(prev => ({
          ...prev,
          [cacheKey]: response.data.areas
        }));

        setAreaSuggestions(response.data.areas);
        setShowAreaSuggestions(true);
      } else {
        setAreaSuggestions([]);
        setShowAreaSuggestions(false);
      }
    } catch (error) {
      console.error('Error fetching area suggestions:', error);
      setAreaSuggestions([]);
      setShowAreaSuggestions(false);
    } finally {
      setIsLoadingAreas(false);
    }
  };

  const saveBuyerSearch = async (searchData) => {
    try {
      const response = await axios.post(
        'https://propertydealstalk.com/api/buyerAnalytics/saveBuyerSearch',
        searchData
      );

      if (response.data.statusCode === 200) {
        console.log('Search saved successfully:', response.data);
      }
    } catch (error) {
      console.error('Error saving search:', error);
    }
  };

  const handleSearch = async () => {
    const isCityValid = validateCity(city);
    const isAreaValid = validateArea(area);

    if (!isCityValid || !isAreaValid) {
      return;
    }

    const hasCity = city && city.trim() !== '';
    const hasArea = area && area.trim() !== '';

    if (!hasCity) {
      showDialog("Please select a city to search", "warning");
      return;
    }

    const params = new URLSearchParams();
    const categoryType = categoryMap[activeTab];

    // Handle Plot tab differently - set asset_type instead of category
    if (activeTab === 'Plot') {
      params.append('asset_type', 'Plot');
    } else if (categoryType) {
      params.append('category', categoryType);
    }

    params.append('city', city.trim());
    
    if (hasArea) {
      params.append('area_name', area.trim());
    }

    if (user && user.id) {
      const searchData = {
        buyer_id: user.id,
        location: city.trim(),
        area: hasArea ? area.trim() : null,
        property_type: null,
        min_price: null,
        max_price: null
      };
      await saveBuyerSearch(searchData);
    }

    navigate({
      pathname: '/property',
      search: params.toString()
    });

    showDialog('Searching for properties...', 'success');
  };

  const handleCityChange = (e) => {
    const value = e.target.value;
    setCity(value);
    validateCity(value);

    if (cityDebounceTimer) {
      clearTimeout(cityDebounceTimer);
    }

    const newTimer = setTimeout(() => {
      if (value.trim().length >= 1) {
        fetchCitySuggestions(value.trim());
      } else {
        setCitySuggestions([]);
        setShowCitySuggestions(false);
        setShowPopularCities(false);
      }
    }, 300);

    setCityDebounceTimer(newTimer);
  };

  const handleAreaChange = (e) => {
    if (!city || city.trim() === '') {
      showDialog("Please select city first", "warning");
      return;
    }

    const value = e.target.value;
    setArea(value);
    validateArea(value);

    if (areaDebounceTimer) {
      clearTimeout(areaDebounceTimer);
    }

    const newTimer = setTimeout(() => {
      if (city && city.trim() !== '') {
        fetchAreaSuggestions(value);
      }
    }, 100);

    setAreaDebounceTimer(newTimer);
  };

  const handleCitySelect = (cityName) => {
    setCity(cityName);
    setCityError('');
    setShowPopularCities(false);
    setShowCitySuggestions(false);
    
    setArea('');
    setAreaSuggestions([]);
    setAreaCacheMap({});
  };

  const handleAreaFocus = (e) => {
    if (!city || city.trim() === '') {
      e.preventDefault();
      e.target.blur();
      showDialog("Please select city first", "warning");
      return;
    }

    if (areaSuggestions.length > 0) {
      setShowAreaSuggestions(true);
    } else if (area.trim().length === 0) {
      fetchAreaSuggestions('');
    }
  };

  const handleAreaClick = (e) => {
    if (!city || city.trim() === '') {
      e.preventDefault();
      showDialog("Please select city first", "warning");
    }
  };

  return (
    <Box
      sx={{
        position: 'relative',
        height: '600px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: 'white',
        fontFamily: 'Outfit',
        px: '16px',
      }}
    >
      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: '250px',
            height: '150px',
            maxWidth: '250px',
            maxHeight: '150px',
          }
        }}
      >
        <DialogTitle id="alert-dialog-title" sx={{ padding: '12px 16px' }}>
          {dialogSeverity === 'success' ? 'Success' :
            dialogSeverity === 'warning' ? 'Warning' :
              dialogSeverity === 'error' ? 'Error' : 'Information'}
        </DialogTitle>
        <DialogContent sx={{ padding: '8px 16px' }}>
          <DialogContentText id="alert-dialog-description">
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: '8px 16px' }}>
          <Button onClick={handleCloseDialog} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.6)',
          zIndex: 1,
        }}
      />

      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          width: '880px',
          maxWidth: '100%',
          fontFamily: 'Outfit',
        }}
      >
        {/* Dynamic Typography based on active tab */}
        <Typography
          variant="h3"
          sx={{
            textAlign: 'center',
            fontWeight: 500,
            mb: '8px',
            fontSize: isMobile ? '28px' : '40px',
            fontFamily: 'Outfit',
          }}
        >
          {getHeadingText()}
        </Typography>

        <Typography
          variant="h6"
          sx={{
            textAlign: 'center',
            fontWeight: 500,
            mb: '32px',
            fontSize: isMobile ? '16px' : '20px',
            fontFamily: 'Outfit',
          }}
        >
          {getSubheadingText()}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: isMobile ? 'center' : 'flex-start',
            flexWrap: 'wrap',
            gap: isMobile ? '5px' : '10px',
            px: isMobile ? '0px' : '30px',
            mb: '0px',
          }}
        >
          {tabs.map((label) => (
            <Box
              key={label}
              onClick={() => setActiveTab(label)}
              sx={{
                width: isMobile ? '100px' : '160px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                fontWeight: 500,
                fontFamily: 'Outfit',
                fontSize: '14px',
                textTransform: 'uppercase',
                cursor: 'pointer',
                backgroundColor: activeTab === label ? '#0052ff' : '#ffffff',
                color: activeTab === label ? '#ffffff' : '#000000',
                boxShadow: activeTab === label ? '0px 2px 8px rgba(0, 0, 0, 0.2)' : 'none',
                border: '1px solid grey',
                transition: 'all 0.3s ease',
                '&:hover': {
                  backgroundColor: activeTab === label ? '#0041cc' : '#f5f5f5',
                },
              }}
            >
              {label}
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            backgroundColor: '#fff',
            borderRadius: '12px',
            padding: '20px',
            mt: '0px',
            ml: isMobile ? '0px' : '24px',
            mr: isMobile ? '0px' : '24px',
            gap: '16px',
            flexWrap: 'wrap',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            fontFamily: 'Outfit',
          }}
        >
          <Box sx={{ position: 'relative', width: isMobile ? '100%' : '320px' }}>
            <TextField
              variant="outlined"
              placeholder="City"
              value={city}
              onChange={handleCityChange}
              onBlur={() => {
                setTimeout(() => {
                  setShowCitySuggestions(false);
                  setShowPopularCities(false);
                }, 200);
              }}
              onFocus={() => {
                if (city.trim().length === 0) {
                  setShowPopularCities(true);
                  setShowCitySuggestions(false);
                } else if (city.trim().length >= 1 && citySuggestions.length > 0) {
                  setShowCitySuggestions(true);
                  setShowPopularCities(false);
                } else if (city.trim().length >= 1) {
                  fetchCitySuggestions(city.trim());
                }
              }}
              fullWidth={isMobile}
              error={!!cityError}
              helperText={cityError}
              sx={{
                width: '100%',
                '& .MuiInputBase-root': {
                  height: '44px',
                  fontFamily: 'Outfit',
                  fontWeight: 500,
                },
                '& input': {
                  padding: '10px 12px',
                  fontWeight: 500,
                  color: '#626262',
                  fontFamily: 'Outfit',
                },
                '& .MuiFormHelperText-root': {
                  color: 'red',
                  marginTop: '2px',
                  fontSize: '12px',
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LocationOnIcon sx={{ color: '#aaa' }} />
                  </InputAdornment>
                ),
              }}
            />

            {showPopularCities && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '44px',
                  left: 0,
                  right: 0,
                  zIndex: 10,
                  maxHeight: '350px',
                  overflowY: 'auto',
                  backgroundColor: '#fff',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  borderRadius: '4px',
                  mt: '4px',
                  border: '1px solid #e0e0e0',
                }}
              >
                <Box sx={{ padding: '12px 16px', backgroundColor: '#f8f9fa' }}>
                  <Typography sx={{ fontWeight: 600, fontSize: '13px', color: '#666', textTransform: 'uppercase' }}>
                    Top Cities
                  </Typography>
                </Box>
                {topCities.map((cityItem, index) => (
                  <Box
                    key={`top-city-${index}`}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '12px 16px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f0f0f0',
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                      },
                      fontFamily: 'Outfit',
                    }}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleCitySelect(cityItem.name);
                    }}
                  >
                    <LocationCityIcon sx={{ color: '#0052ff', fontSize: '20px', mr: 1.5 }} />
                    <Box>
                      <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#333' }}>
                        {cityItem.name}
                      </Typography>
                      <Typography sx={{ fontSize: '12px', color: '#999' }}>
                        {cityItem.state}
                      </Typography>
                    </Box>
                  </Box>
                ))}

                <Divider sx={{ my: 1 }} />

                <Box sx={{ padding: '12px 16px', backgroundColor: '#f8f9fa' }}>
                  <Typography sx={{ fontWeight: 600, fontSize: '13px', color: '#666', textTransform: 'uppercase' }}>
                    Other Cities
                  </Typography>
                </Box>
                {otherCities.map((cityItem, index) => (
                  <Box
                    key={`other-city-${index}`}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '12px 16px',
                      cursor: 'pointer',
                      borderBottom: index < otherCities.length - 1 ? '1px solid #f0f0f0' : 'none',
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                      },
                      fontFamily: 'Outfit',
                    }}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleCitySelect(cityItem.name);
                    }}
                  >
                    <LocationOnIcon sx={{ color: '#666', fontSize: '20px', mr: 1.5 }} />
                    <Box>
                      <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#333' }}>
                        {cityItem.name}
                      </Typography>
                      <Typography sx={{ fontSize: '12px', color: '#999' }}>
                        {cityItem.state}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}

            {showCitySuggestions && citySuggestions.length > 0 && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '44px',
                  left: 0,
                  right: 0,
                  zIndex: 10,
                  maxHeight: '200px',
                  overflowY: 'auto',
                  backgroundColor: '#fff',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  borderRadius: '4px',
                  mt: '4px',
                  border: '1px solid #e0e0e0',
                }}
              >
                {citySuggestions.map((suggestion, index) => (
                  <Box
                    key={`city-${suggestion.id}-${index}`}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '10px 12px',
                      cursor: 'pointer',
                      borderBottom: index < citySuggestions.length - 1 ? '1px solid #f0f0f0' : 'none',
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                      },
                      fontFamily: 'Outfit',
                    }}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setCity(suggestion.name);
                      setCityError('');
                      setShowCitySuggestions(false);
                      setArea('');
                      setAreaSuggestions([]);
                      setAreaCacheMap({});
                    }}
                  >
                    <LocationOnIcon sx={{ color: '#666', fontSize: '20px', mr: 1.5 }} />
                    <Box>
                      <Typography sx={{ fontWeight: 900, fontSize: '14px', color: '#333' }}>
                        {suggestion.name}
                      </Typography>
                      {suggestion.state_name && (
                        <Typography sx={{ fontWeight: 500, fontSize: '12px', color: '#999' }}>
                          {suggestion.state_name}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </Box>

          <Box sx={{ position: 'relative', width: isMobile ? '100%' : '320px' }}>
            <TextField
              variant="outlined"
              placeholder="Area"
              value={area}
              onChange={handleAreaChange}
              onClick={handleAreaClick}
              onBlur={() => {
                setTimeout(() => setShowAreaSuggestions(false), 200);
              }}
              onFocus={handleAreaFocus}
              fullWidth={isMobile}
              error={!!areaError}
              helperText={areaError}
              sx={{
                width: '100%',
                '& .MuiInputBase-root': {
                  height: '44px',
                  fontFamily: 'Outfit',
                  fontWeight: 500,
                  cursor: (!city || city.trim() === '') ? 'not-allowed' : 'text',
                },
                '& input': {
                  padding: '10px 12px',
                  fontWeight: 500,
                  color: (!city || city.trim() === '') ? '#aaa' : '#626262',
                  fontFamily: 'Outfit',
                  cursor: (!city || city.trim() === '') ? 'not-allowed' : 'text',
                },
                '& .MuiFormHelperText-root': {
                  color: 'red',
                  marginTop: '2px',
                  fontSize: '12px',
                },
              }}
            />

            {showAreaSuggestions && !isLoadingAreas && areaSuggestions.length > 0 && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '44px',
                  left: 0,
                  right: 0,
                  zIndex: 10,
                  maxHeight: '200px',
                  overflowY: 'auto',
                  backgroundColor: '#fff',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  borderRadius: '4px',
                  mt: '4px',
                  border: '1px solid #e0e0e0',
                }}
              >
                {areaSuggestions.map((suggestion, index) => (
                  <Box
                    key={`area-${index}-${suggestion.name}`}
                    sx={{
                      padding: '10px 12px',
                      cursor: 'pointer',
                      borderBottom: index < areaSuggestions.length - 1 ? '1px solid #f0f0f0' : 'none',
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                      },
                      fontFamily: 'Outfit',
                      fontWeight: 500,
                      color: '#626262',
                    }}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setArea(suggestion.name);
                      setAreaError('');
                      setShowAreaSuggestions(false);
                    }}
                  >
                    <Box>
                      <Typography sx={{ fontWeight: 500, fontSize: '14px' }}>
                        {suggestion.name}
                      </Typography>
                      {suggestion.address && (
                        <Typography sx={{ fontSize: '12px', color: '#999' }}>
                          {suggestion.address}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </Box>

          {/* Search Button */}
          <Button
            onMouseDown={(e) => {
              e.preventDefault();
            }}
            onClick={handleSearch}
            variant="contained"
            sx={{
              bgcolor: '#0052ff',
              color: '#fff',
              width: isMobile ? '100%' : '120px',
              height: '44px',
              textTransform: 'none',
              fontWeight: 500,
              fontFamily: 'Outfit',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#003dcc',
              },
            }}
          >
            Search
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default HeroSection;

